import BaseClass from "./BaseClass";
import Period from "./subClasses/Period";

export default class SharedPeriods extends BaseClass {
  constructor(data) {
    super(data);
    if (!Array.isArray(this.periods)) {
      this.periods = Period.getSelfList(Object.values(this.periods));
    } else {
      this.periods = Period.getSelfList(this.periods);
    }
  }

  get actualPeriod() {
    return this.periods.reduce((r, p) => {
      return p.getActual(r);
    }, null);
  }

  _mutate(action = "save") {
    return this._api.mutate({
      mutation: require("../../graphql/shared-periods/shared_periods_mutation.graphql"),
      variables: Object.assign({ action }, { data: this })
    });
  }

  _handleSave() {
    return this._mutate().then(res => {
      Object.assign(this, new this.constructor(res.data.shared_periods));
      return "saved";
    });
  }

  _handleDelete() {
    return this._mutate("delete").then(res => {
      return "deleted";
    });
  }
}
